import { gql } from '@apollo/client';
import { UsersData } from './users_data';

export const GET_USER_BY_ID = gql`
query User_getById($id: String!) {
  User_getById(id: $id) {
    ${UsersData}
  }
}
`;

export const GET_USER_BY_FIREBASE_ID = gql`
query User_getByFireBaseId($id: String!) {
  User_getByFireBaseId(id: $id) {
    ${UsersData}
  }
}
`;

export const GET_BU_OF_CURRENT_USER = gql`
  query User_getBuOfCurrentUser($id: String!) {
    User_getBU(id: $id) {
      id
      businessUnit
    }
  }
`;
